import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@anytag/shared-atoms';
import { UGCPostStatus as UGCPostStatusType } from '@anytag/graphql';
import { IconNames } from '@anytag/shared-assets';

export interface UGCPostStatusProps {
  status: UGCPostStatusType | null;
}

export const UGCPostStatus = ({ status }: UGCPostStatusProps) => {
  const { t } = useTranslation();

  const isNotRequested = status === UGCPostStatusType.NOT_REQUESTED;
  const statusData = ((): {
    label: string;
    iconProps: { icon: IconNames; size: number };
    className: string;
    iconClassName: string;
  } | null => {
    switch (status) {
      case UGCPostStatusType.REQUESTED:
        return {
          label: t('Option.UGC Requested'),
          iconProps: { icon: 'warning-circle', size: 14 },
          className: 'bg-[#FFF4E2]',
          iconClassName: 'text-[#FFB63D]'
        };
      case UGCPostStatusType.APPROVED:
        return {
          label: t('Option.UGC Approved'),
          iconProps: { icon: 'success', size: 14 },
          className: 'bg-[#E2F4EB]',
          iconClassName: 'text-[#40B87C]'
        };
      case UGCPostStatusType.REJECTED:
        return {
          label: t('Option.UGC Rejected'),
          iconProps: { icon: 'close', size: 9 },
          className: 'bg-[#FFE7E7]',
          iconClassName: 'text-[#FF5F5F]'
        };
      default:
        return null;
    }
  })();

  return !isNotRequested && statusData ? (
    <div css={[styles.wrapper, statusData.className]}>
      <Icon variant="inherit" {...statusData.iconProps} className={statusData.iconClassName} />
      {statusData.label}
    </div>
  ) : null;
};
const styles = {
  wrapper: css({
    top: 0,
    left: 0,
    zIndex: 1,
    fontWeight: 600,
    gap: '4px',
    display: 'flex',
    padding: '4px',
    fontSize: '10px',
    position: 'absolute',
    alignItems: 'center',
    boxSizing: 'border-box',
    borderBottomRightRadius: '5px'
  })
};
